module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tutorial":"Tutorial","tutorialLink":"https://bonuscloud.club/viewforum.php?f=19","guide":"Guide","guideLink":"https://bonuscloud.club/viewtopic.php?f=18&t=17"},"zn":{"tutorial":"刷机教程","tutorialLink":"https://bonuscloud.club/viewtopic.php?f=15&t=2014","guide":"新手入门","guideLink":"https://bonuscloud.club/viewtopic.php?f=15&t=12"}}')
  delete Component.options._Ctor
}
